import styled from 'styled-components';

export const Button = styled.button`
  background-color: #005bff;
  border: 1px solid transparent;
  border-color: #005bff;
  border-radius: 12px;
  color: #fff;
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
    'Courier New', monospace;
  font-size: 14px;
  font-weight: 700;
  height: 36px;
  line-height: 15px;
  padding: 0.375rem 0.75rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:not(:disabled) {
    cursor: pointer;
  }
`;
